{
  "pageTitle": "تبرع الآن",
  "weBelieve": "نؤمن بأن",
  "everyTalented": "كل طالب موهوب",
  "anOpportunity": "يستحق الحصول على فرصة",
  "foundationsTitle1": "تقدم لنا الدعم",
  "foundationsTitle2": "هيئات دولية",
  "foundationsTitle3": "غير هادفة للربح",
  "foundationsDescription1": "نوفر للهيئات والشخصيات المانحة فرصة تغيير حياة الأطفال الذين يُظهرون إمكانات أكاديمية وقيادية كبيرة من خلال منحهم إمكانية الحصول على تعليم ذو مستوى عالمي.",
  "foundationsDescription2": "الجهات المانحة للمنارة يمكنهم المساعدة في تحقيق تكافؤ الفرص للأطفال الأقل حظًا في مصر من خلال توفير فرصة الالتحاق بالبرنامج التحضيري للجامعة الذي سيؤهل الطلبة للنجاح في الدراسة الجامعية وما بعدها.",
  "donateNow": "تبرع الآن",
  "donationsError": "فشل في الحصول على بيانات التبرعات",
  "ourMissionTitle1": "تعزيز القدرات القيادية لدى الطلاب لصنع",
  "ourMissionTitle2": "قادة مجتمعنا المستقبليين",
  "ourMissionLink": "نبذة عن رسالتنا",
  "academicStructureTitle1": "نقدم منهج دراسي دولي يعد الطلاب للالتحاق",
  "academicStructureTitle2": "بالجامعة ويتضمن مساحة للاستكشاف",
  "academicStructureLink": "الهيكل الأكاديمي",
  "donateConfirm": "تبرع",
  "donationAmount": "المبلغ",
  "donationAmountRequired": "المبلغ مطلوب",

  "paymentMethod": "طريقة الدفع",
  "paymentMethodDescription": "نقدم خيارات دفع آمنة ومريحة لضمان تجربة معاملة سلسة",
  "byCreditCard": "بواسطة بطاقة الائتمان",
  "byWireTransfer": "بواسطة التحويل البنكي",

  "donateViaWireTransfer": "تبرع بواسطة التحويل البنكي",
  "donateViaWireTransferDescription": "إذا كنت ترغب في التبرع عبر التحويل البنكي، يرجى إرسال بريد إلكتروني إلى",
  "donateViaWireTransferDescription2": "، وسنرسل لك تعليمات التحويل.",

  "firstNameLabel": "الاسم الأول",
  "firstNamePlaceholder": "محمد",
  "firstNameError": "مطلوب الاسم الأول!",
  "lastNameLabel": "الاسم الأخير",
  "lastNamePlaceholder": "أحمد",
  "lastNameError": "مطلوب الاسم الأخير!",
  "emailLabel": "البريد الإلكتروني",
  "emailPlaceholder": "example@example.com",
  "emailError": "يجب ادخال بريد إلكتروني يوافق الصيغة التالية ex@example.com",
  "emailRequired": "مطلوب البريد الإلكتروني!",
  "phoneNumberLabel": "رقم الهاتف",
  "phoneNumberPlaceholder": "010 000 000 00",
  "phoneNumberRequired": "مطلوب رقم الهاتف!",
  "applyHere": "قدم هنا",

  "addressRequired": "مطلوب العنوان",
  "cityRequired": "مطلوب المدينة",
  "countryRequired": "مطلوب الدولة",
  "zipCodeRequired": "مطلوب الرمز البريدي",
  "stateRequired": "مطلوب الولاية",
  "addressLabel": "العنوان",
  "addressPlaceholder": "العنوان",
  "cityLabel": "المدينة",
  "cityPlaceholder": "المدينة",
  "countryLabel": "الدولة",
  "countryPlaceholder": "الدولة",
  "zipCodeLabel": "الرمز البريدي",
  "zipCodePlaceholder": "الرمز البريدي",
  "stateLabel": "الولاية",
  "statePlaceholder": "الولاية",

  "amountMustBeNumber": "المبلغ يجب أن يكون رقمًا",
  "amountMustBePositive": "المبلغ يجب أن يكون موجبًا",
  "invalidEmail": "البريد الإلكتروني غير صحيح"
}
